import React from 'react';
import { motion } from 'framer-motion';

const ConfirmationPopup = ({
  showCampaignConfirmation,
  handleDownloadWithoutCampaign,
  handleConfirmCampaign,
  closeConfirmationPopup,
  downloading
}) => {
  if (!showCampaignConfirmation) return null;

  return (
    <div className="campaign-confirmation-overlay">
      <motion.div 
        className="campaign-confirmation-popup"
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.8 }}
      >
        <button onClick={closeConfirmationPopup} className="close-confirmation-btn">×</button>
        <h3>Is this for a campaign?</h3>
        <p>Do you want to add campaign information before downloading the filtered data?</p>
        <div className="confirmation-actions">
          <button 
            onClick={handleDownloadWithoutCampaign} 
            className="no-btn"
            disabled={downloading}
            style={{
              opacity: downloading ? 0.6 : 1,
              cursor: downloading ? 'not-allowed' : 'pointer'
            }}
          >
            {downloading ? (
              <>
                <span className="loading-spinner" style={{ 
                  display: 'inline-block', 
                  width: '16px', 
                  height: '16px', 
                  border: '2px solid #ffffff', 
                  borderTop: '2px solid transparent', 
                  borderRadius: '50%', 
                  animation: 'spin 1s linear infinite',
                  marginRight: '8px'
                }}></span>
                Downloading...
              </>
            ) : (
              'No, Download Directly'
            )}
          </button>
          <button onClick={handleConfirmCampaign} className="yes-btn">Yes, Add Campaign Info</button>
        </div>
      </motion.div>
    </div>
  );
};

export default ConfirmationPopup;
